import { createStore } from 'satcheljs';
export default createStore('exportMailboxOption', {
    isExportMailboxRequestMade: undefined,
    requestStatus: undefined,
    downloadLink: undefined,
});
//# sourceMappingURL=store.js.map